module.exports = __webpack_public_path__ + "img/NZ.180ef6f7.png";